function helperDefaultCompare (v1, v2) {
  return v1 === v2
}

module.exports = helperDefaultCompare



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperDefaultCompare.js
// module id = 9nb2
// module chunks = 141